import { useMemo } from 'react';
import ActivityTypeIcon from '../../ActivityTypeIcon/ActivityTypeIcon';
import Colors from '@/constants/Colors';
import { StyledThemeActivityIcons } from './ThemeActivityIcons.styled';
import ActivityTypes from '@/constants/ActivityTypes';

export default function ThemeActivityIcons({ theme }) {
  const typesCount = useMemo(
    () => countActivityTypes(theme.activities),
    [theme]
  );

  return (
    <StyledThemeActivityIcons>
      {typesCount.map(({ type, count }) => (
        <div className="theme-activity-icon" key={type}>
          <ActivityTypeIcon
            type={type}
            color="white"
            withCircle
            circleColor={Colors.activityTypeColors[type]}
            size={10}
            width={20}
            height={20}
          />
          {count > 1 && <span className="count">{count}</span>}
        </div>
      ))}
    </StyledThemeActivityIcons>
  );
}

function countActivityTypes(activities) {
  const typesCount = ActivityTypes.typesOrdered.reduce((result, type) => {
    return [
      ...result,
      {
        type,
        count: activities?.filter((activity) => activity.type == type).length,
      },
    ];
  }, []);
  return typesCount.filter((item) => item.count > 0);
}
